import React, { Component } from "react";
import {
  Button, Card, CardBody, CardHeader, Col, Row,
  ButtonToolbar, ButtonGroup, Container
} from "reactstrap";
import { bindActionCreators } from 'redux';
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import ReactTable from 'react-table'
import LoadingIcon from "mdi-react/LoadingIcon";
import SettingsIcon from 'mdi-react/SettingsIcon';

import {
  getInference,
  openInference,
  deleteInferece
} from "../../redux/actions/inferenceActions";
import DeletePopUP from "../../shared/components/deletePopUp";

export class Inference extends Component {
  constructor(props) {
    super(props);
    this.state = {
      dataLoaded: false,
      showDeleteAlert: false,
      selectedInference: null,
    };
  }

  componentWillMount() {
    const { getInference } = this.props;
    getInference({});
  }

  componentWillReceiveProps = nextProps => {
    if (nextProps.inference){
      this.setState ({
        dataLoaded:true,
        formType: null,
        showDeleteAlert: false,
        selectedInference:null
      });
    }
  };

  openForm = (type, selectedInference) => {
    if (selectedInference){
      selectedInference["formType"]= type;
      this.props.openInference(selectedInference);
    } else{
      this.props.openInference(null);
    }

    this.props.history.push("/inference/create_update_inference");
  };

  renderActionButton2 = props => {
    return (
      <div className="text-right">
        <Button
          className="icon rm-m-b"
          color="primary"
          onClick={() => this.openForm("create")}
        >
          <p><SettingsIcon /> New Inference</p>
        </Button>
      </div>
    );
  };

  renderActionButtons = row => {
    return (
      <div className="text-center">
        <ButtonToolbar>
          <ButtonGroup className="btn-group--icons" dir="ltr">
            <Button
              outline color="success"
              onClick={() => this.openForm("update", row)}
            >
              <span className="lnr lnr-pencil" />
            </Button>
            <Button
              outline color="warning"
              onClick={() => this.openForm("clone", row)}
            >
              <span className="lnr lnr-plus-circle" />
            </Button>
            <Button
              outline color="danger"
              onClick={() =>
                this.setState({
                  showDeleteAlert: true,
                  selectedInference: row
                })
              }
            >
              <span className="lnr lnr-cross" />
            </Button>
          </ButtonGroup>
        </ButtonToolbar>
      </div>
    );
  };

  reactTableFetchDataHandler = (state, instance) => {

    const { getInference } = this.props;

    let filterFieldData = '';
    state.filtered.filter(columnName =>
      filterFieldData = filterFieldData + '&' + columnName.id + '=' + columnName.value);

    const sortBy =
      state.sorted && state.sorted.length > 0 && state.sorted[0].id
        ? state.sorted[0].id : '';

    getInference({
      page: state.page,
      perPage: state.pageSize,
      filterFieldData: filterFieldData.substring(1),
      sortBy,
    });
  }

  render () {
    const { showDeleteAlert, selectedInference } = this.state;
    const { loadingInference, deleteInferece, t, inferences, totalPages } = this.props;

    const columns = [
      {
        Header: t('inference_services.inference_label.name'),
        accessor: 'inference_name',
      },{
        Header: t('inference_services.inference_label.collection_name'),
        accessor: 'collection_name',
      },{
        Header: t('inference_services.inference_label.service_status'),
        accessor: 'activity_status',
        Filter: ({ filter, onChange }) =>
          <select
            onChange={event => onChange(event.target.value)}
            style={{ width: "100%" }}
            value={filter ? filter.value : "all"}
            className={'table-filter-dropdown'}
          >
            <option value="">Show All</option>
            <option value="ACTIVE">ACTIVE</option>
            <option value="OUT_OF_SERVICE">OUT OF SERVICE</option>
            <option value="DOWN">DOWN</option>
          </select>
      }, {
        Header: t('inference_services.inference_label.updated_on'),
        accessor: 'updatedDate'
      },{
        Header: t('inference_services.inference_label.actions'),
        filterable: false,
        sortable: false,
        Cell: original => this.renderActionButtons(original.original)
      }
    ];

    return (
      <Container>
        <React.Fragment>
          {
            loadingInference ? (
              <Row>
                <Card>
                  <CardHeader>
                    <div className="form__form-group-icon">
                      <LoadingIcon />
                    </div>
                    Loading Inferences
                  </CardHeader>
                  <CardBody>
                    <div></div>
                  </CardBody>
                </Card>
              </Row>
            ) : (
              <Row>
                <Col md={12}>
                  <h3 className="page-title">{t('inference_services.create_update_inference.title')}</h3>
                  <h3 className="page-subhead subhead">{t('inference_services.create_update_inference.sub_title')}
                  </h3>

                  <Card>
                    <CardHeader >
                      {t('inference_services.title')}
                    </CardHeader>
                    <CardBody>
                      {this.renderActionButton2()}
                      <ReactTable
                        data={inferences}
                        columns={columns}
                        className='assetsList'
                        filterable
                        minRows = {0}
                        defaultFilterMethod={(filter, row) =>
                          String(row[filter.id]) === filter.value}
                        loading={loadingInference}
                        showPagination={true}
                        showPaginationTop={false}
                        showPaginationBottom={true}
                        pageSizeOptions={[5, 10, 20, 25, 50, 100]}
                        pages={
                          totalPages ? totalPages : 1
                        }
                        manual
                        onFetchData={(state, instance) => this.reactTableFetchDataHandler(state, instance)}
                      />
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            )
          }
          <DeletePopUP
            title="Are you sure, you want to delete this Asset?"
            showDeleteAlert={ showDeleteAlert }
            onDelete={() => {
              deleteInferece(selectedInference);
              return this.setState({ showDeleteAlert: false });
            }}
            onCancel={() => this.setState({ showDeleteAlert: false })
            }
          />

        </React.Fragment>
      </Container>
    );
  }
}

Inference.propTypes = {
  t: PropTypes.func.isRequired,
  openInference: PropTypes.func.isRequired,
  deleteInferece: PropTypes.func.isRequired,
  selectedInference: PropTypes.any,
  selectedAsset: PropTypes.any,

  getInference: PropTypes.func.isRequired,
  inferences: PropTypes.array,
};

function mapStateToProps({ component, inference }) {
  return {
    inferences: inference.inferences,
    selectedInference: inference.selectedInference,
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      openInference,
      deleteInferece,
      getInference,
    },
    dispatch
  );
}

export default withTranslation('common') (
  connect(
    mapStateToProps,
    mapDispatchToProps,
  )(Inference)
);
